<script>
export default {
  props: {
    show: Boolean,
    mesas:[],
  }
  ,data: function () {
    return {
      
      mesaSeleccionada:null,
    }
},
computed: {
  mesasFiltradas() {
    return this.mesas.filter(mesa => mesa.estado !== 'OCUPADA');
  }
}
};
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" style="max-height: 70vh; overflow-y: auto; ">
          <div class="modal-header">
            <div>
              <img src="@/assets/logo-azul.png" id="icon" alt="User Icon" />
            </div>
          </div>
          <div class="modal-body">
            <label> Seleccionar mesa a ocupar por el comensal</label>
            <br>
            <select class="form-select" v-model="mesaSeleccionada" style="text-align: center;">
      <option v-for="mesa in mesasFiltradas" :key="mesa.id" :value="mesa">
        Mesa N°{{ mesa.numero }} - {{ mesa.cantidadComensales }} comensales
      </option>
    </select>
          </div>

          <div class="modal-footer" style="display: block;">

            <button class="btn btn-danger" style="width: 100px;" @click="$emit('close')">
              Cancelar
            </button>
            <button class="btn btn-success" style="width: 100px;" @click="$emit('confirmar',mesaSeleccionada)">
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 800px !important;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  
}

.modal-header h3 {
  margin-top: 0;

}
.modal-header{
    display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.modal-body {
      display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
